/** Страница запроса сброса пароля: отправляет на e-mail код для восстановления доступа. */
import { useForm } from "@tanstack/react-form";
import { useState } from "react";
import { Link } from "react-router-dom";
import { z } from "zod";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const requestPasswordResetSchema = z.object({
	email: z
		.string()
		.min(1, "Введите электронную почту")
		.email("Введите корректную электронную почту"),
});

export const RequestPasswordResetPage = () => {
	const [isSubmitted, setIsSubmitted] = useState(false);
	const requestPasswordResetApi = apiHooks.auth.useRequestPasswordReset();
	const form = useForm({
		defaultValues: { email: "" },
		validators: { onChange: requestPasswordResetSchema },
		onSubmit: async ({ value }) => {
			const response = await requestPasswordResetApi.execute(value);
			if (response.error !== null) return;
			setIsSubmitted(true);
		},
	});

	return (
		<div className="flex flex-1 items-center justify-center overflow-y-auto px-5 py-10">
			<form className="w-full max-w-sm" action={() => form.handleSubmit()}>
				<UIKit.Text className="mb-2 font-medium text-accent">GRID PLANNER</UIKit.Text>
				<UIKit.Text size="xl">Восстановить пароль</UIKit.Text>
				<UIKit.Text className="mt-2 text-ink">Отправим код для создания нового пароля.</UIKit.Text>
				<div className="mt-7">
					<UIKit.FormField form={form} name="email">
						{(field) => (
							<UIKit.TextInput
								label="Электронная почта"
								type="email"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="email"
							/>
						)}
					</UIKit.FormField>
				</div>
				{isSubmitted && (
					<UIKit.Text className="mt-4 text-green-700">
						Код отправлен. Введите его на следующем шаге.
					</UIKit.Text>
				)}
				<UIKit.Button
					className="mt-6 w-full border-accent bg-accent py-3 text-sm font-medium text-overlay-ink hover:border-accent-hover hover:bg-accent-hover"
					type="submit"
					disabled={requestPasswordResetApi.isPending}
				>
					{requestPasswordResetApi.isPending ? "Отправляем..." : "Отправить код"}
				</UIKit.Button>
				<UIKit.Text className="mt-5 text-center text-ink">
					<Link
						className="font-medium text-accent hover:underline"
						to={routerPaths.passwordResetConfirm}
					>
						Уже есть код
					</Link>{" "}
					·{" "}
					<Link className="font-medium text-accent hover:underline" to={routerPaths.login}>
						Войти
					</Link>
				</UIKit.Text>
			</form>
		</div>
	);
};
